"use strict";

exports.__esModule = true;
exports.StripeChartFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _getInstantaneousTimelineEvents = require("./getInstantaneousTimelineEvents");
var _reactIntl = require("react-intl");
var _dec, _class, _StripeChartFields;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "StripeChartFields__AxisControls",
  componentId: "sc-1vizzeo-0"
})(["display:flex;label{flex:1;}"]);

/**
 * Fields for StripeChartElement.
 */
var StripeChartFields = exports.StripeChartFields = (_dec = _ConfigurableLayout.LayoutSettingsContext.withContext, _dec(_class = (_StripeChartFields = /*#__PURE__*/function (_Component) {
  function StripeChartFields() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(StripeChartFields, _Component);
  var _proto = StripeChartFields.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      element = _this$props.element,
      path = _this$props.path,
      elementEditor = _this$props.elementEditor,
      layoutSettings = _this$props.layoutSettings;
    var eventTypes = (0, _getInstantaneousTimelineEvents.getAllInstantaneousEventTypes)();
    var canBrush = element.props.dataRange !== "SELECTION";
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("StripeChartFields.timeline.label", "Timeline")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement("select", {
        value: element.props.timeline || _timelineDefinitions.TIME_SERIES_CLASSIFICATION,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "timeline", e.target.value || undefined);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: _timelineDefinitions.TIME_SERIES_CLASSIFICATION
      }, translate("StripeChartFields.timeline.classification.label", "Classification")), /*#__PURE__*/_react["default"].createElement("option", {
        value: _timelineDefinitions.TIME_SERIES_SHIFT
      }, translate("StripeChartFields.timeline.shift.label", "Shift")), /*#__PURE__*/_react["default"].createElement("option", {
        value: _timelineDefinitions.TIME_SERIES_KIND
      }, translate("StripeChartFields.timeline.partKind.label", "Part Kind")), /*#__PURE__*/_react["default"].createElement("option", {
        value: _timelineDefinitions.TIME_SERIES_PROCESS
      }, translate("StripeChartFields.timeline.process.label", "Part Process")), /*#__PURE__*/_react["default"].createElement("option", {
        value: _timelineDefinitions.TIME_SERIES_INSTANCE
      }, translate("StripeChartFields.timeline.instance.label", "Part Instance"))))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, null, /*#__PURE__*/_react["default"].createElement("input", {
        id: "showDivision",
        type: "checkbox",
        checked: element.props.showDivision || false,
        onChange: function onChange() {
          return elementEditor.setProp(path, "showDivision", !element.props.showDivision);
        }
      }), " ", translate("StripeChartFields.showDivision.label", "Division"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("input", {
        id: "showLabel",
        type: "checkbox",
        checked: element.props.showLabel || false,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "showLabel", e.target.checked);
        }
      }), " ", translate("StripeChartFields.showLabel.label", "Show Label")), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("StripeChartFields.axes.label", "Axes"),
        helperText: translate("StripeChartFields.axes.helperText", "Show / hide the chart axes.")
      }, /*#__PURE__*/_react["default"].createElement(AxisControls, null, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "hideXAxis"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "hideXAxis",
        type: "checkbox",
        checked: element.props.hideXAxis || false,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "hideXAxis", e.target.checked);
        }
      }), " ", translate("StripeChartFields.axes.hideXAxis.label", "Hide X Axis")))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, null, eventTypes.map(function (eventType) {
        var prop = "show" + eventType;
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: eventType
        }, /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: prop
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: prop,
          type: "checkbox",
          checked: element.props[prop] || false,
          onChange: function onChange(e) {
            return elementEditor.setProp(path, prop, e.target.checked);
          }
        }), " ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "StripeChartFields." + eventType + ".label",
          defaultMessage: "Show " + eventType
        })), /*#__PURE__*/_react["default"].createElement("br", null));
      })), layoutSettings.stripeChart.allowSelection && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("StripeChartFields.dataRange.label", "Data Range"),
        helperText: translate("StripeChartFields.dataRange.helperText", "The data range to show in this stripe chart.")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement("select", {
        value: element.props.dataRange || "",
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "dataRange", e.target.value || undefined);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, translate("StripeChartFields.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
        value: "SELECTION"
      }, translate("StripeChartFields.dataRange.selection.label", "Selection"))))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        helperText: canBrush ? translate("StripeChartFields.showBrush.label", "Enable brushing a selection on the chart.") : translate("StripeChartFields.showBrush.label.disabled", "Brushing is only available when using Reporting Period for the Date Range.")
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "showBrush"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "showBrush",
        type: "checkbox",
        disabled: !canBrush,
        checked: canBrush ? element.props.showBrush || false : false,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "showBrush", e.target.checked);
        }
      }), " ", translate("StripeChartFields.showBrush.allowSelection.label", "Allow selection"))), element.props.showBrush && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("StripeChartFields.brushEnableDragging.label", "Brush")
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "enableDragging"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "enableDragging",
        type: "checkbox",
        checked: element.props.brushEnableDragging === undefined ? true : element.props.brushEnableDragging,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "brushEnableDragging", e.target.checked);
        }
      }), " ", translate("StripeChartFields.brushEnableDragging.allowDragging.label", "Allow dragging")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "brushEnableResize"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "brushEnableResize",
        type: "checkbox",
        checked: element.props.brushEnableResize === undefined ? true : element.props.brushEnableResize,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "brushEnableResize", e.target.checked);
        }
      }), " ", translate("StripeChartFields.brushEnableResize.allowResizing.label", "Allow resizing")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "brushEnableSnapToSelection"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "brushEnableSnapToSelection",
        type: "checkbox",
        checked: element.props.brushEnableSnapToSelection === undefined ? true : element.props.brushEnableSnapToSelection,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "brushEnableSnapToSelection", e.target.checked);
        }
      }), " ", translate("StripeChartFields.brushEnableSnapToSelection.clickToSelect.label", "Click to select")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "brushEnableSnapToTimeline"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "brushEnableSnapToTimeline",
        type: "checkbox",
        checked: element.props.brushEnableSnapToTimeline === undefined ? true : element.props.brushEnableSnapToTimeline,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "brushEnableSnapToTimeline", e.target.checked);
        }
      }), " ", translate("StripeChartFields.brushEnableSnapToTimeline.snapToEdge.label", "Snap to edge")), /*#__PURE__*/_react["default"].createElement("br", null))));
    });
  };
  return StripeChartFields;
}(_react.Component), _StripeChartFields.defaultProps = {
  layoutSettings: undefined
}, _StripeChartFields)) || _class);